/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';

import { FlexCol } from 'sarsaparilla';

import ContestCard from '../ContestCard';

export function ItemsPlaceholder() {
    return (
        <FlexCol sm={6} md={4} xl={3} className="mb-4">
            <ContestCard href="#" imagePath="" imageAlt="" heading="" isLoading />
        </FlexCol>
    );
}
